import styled from 'styled-components';

import { Text } from '../../../../cdl/Text/Text';
import { formatDateTime } from '../../../../common/helpers/formatDateTime.helper';
import { translate } from '../../../../common/helpers/translate.helper';
import { OfferStatusTag } from '../../../../common/OfferStatusTag/OfferStatusTag';
import { Box } from '../../../../common/ui/Box';
import { theme } from '../../../../common/ui/theme';
import { OfferHistoryTransition } from '../../history/buildOfferHistoryTransitions';

const TimelineScroll = styled(Box)`
    display: flex;
    gap: ${theme.space[12]};
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: ${theme.space[8]};
`;

const TimelineButton = styled.button<{ $active: boolean }>`
    flex: 0 0 240px;
    border: 1px solid ${theme.colors.border.muted};
    border-radius: ${theme.radii[8]};
    background: ${({ $active }) => ($active ? theme.colors.accent.background : theme.colors.background.default)};
    box-shadow: ${({ $active }) => ($active ? theme.shadows.border.default : 'none')};
    padding: ${theme.space[16]};
    text-align: left;
`;

const TimelineTimestamp = styled(Text)`
    white-space: nowrap;
`;

interface OfferHistoryTimelineProps {
    transitions: OfferHistoryTransition[];
    selectedTransitionId: string;
    onSelect: (transitionId: string) => void;
}

export const OfferHistoryTimeline = ({ transitions, selectedTransitionId, onSelect }: OfferHistoryTimelineProps) => {
    return (
        <TimelineScroll>
            {transitions.map((transition) => (
                <TimelineButton
                    key={transition.id}
                    type="button"
                    $active={transition.id === selectedTransitionId}
                    onClick={() => onSelect(transition.id)}
                >
                    <Box display="flex" flexDirection="column" gap={12}>
                        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={8}>
                            <TimelineTimestamp variant="fieldLabel">
                                {formatDateTime({ date: transition.timestamp })}
                            </TimelineTimestamp>
                            <OfferStatusTag state={transition.after.state} variant="customer" />
                        </Box>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <Text variant="fieldLabel" color="foreground.muted">
                                {translate('offer.history.field.actor')}
                            </Text>
                            <Text variant="extraSmall" color="foreground.muted">
                                {transition.actorName ?? translate('offer.history.actorUnknown')}
                            </Text>
                        </Box>
                    </Box>
                </TimelineButton>
            ))}
        </TimelineScroll>
    );
};
